"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var Fontpicker = /*#__PURE__*/function (_Component) {
  _inherits(Fontpicker, _Component);

  var _super = _createSuper(Fontpicker);

  function Fontpicker() {
    var _this;

    _classCallCheck(this, Fontpicker);

    _this = _super.call(this);
    _this.state = {
      fonts: null
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Fontpicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var apiKey = this.props.apiKey || 'AIzaSyBefCxz75-gaSRPZNdEaH8YpulE8lwRb_g';
      var url = 'https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=' + apiKey;
      fetch(url).then(function (res) {
        return res.json();
      }).then(function (result) {
        _this2.setState({
          fonts: result.items.slice(0, 20)
        });
      }, function (error) {// 
      });
    }
  }, {
    key: "onClick",
    value: function onClick(e) {}
  }, {
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var fontsMeta = this.state.fonts && this.state.fonts.map(function (font) {
        return /*#__PURE__*/_react.default.createElement("link", {
          href: "https://fonts.googleapis.com/css2?family=".concat(font.family.replace(' ', '+'), ":wght@300&display=swap"),
          rel: "stylesheet"
        });
      });
      var options = this.state.fonts && this.state.fonts.map(function (font) {
        return /*#__PURE__*/_react.default.createElement(_.Select.Option, {
          key: font.family
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontFamily: font.family
          },
          value: font
        }, font.family));
      });
      return /*#__PURE__*/_react.default.createElement("div", null, fontsMeta, /*#__PURE__*/_react.default.createElement(_.Select, this.props, options || []));
    }
  }]);

  return Fontpicker;
}(_component.default);
/*---------------------------------------------*/


exports.default = Fontpicker;

_defineProperty(Fontpicker, "BASE_CLASS", 'lth-c-fontpicker');

Fontpicker.METADATA = {
  name: 'Fontpicker',
  props: []
};